import { axiosAuth } from '_utils/axios';
export async function generateCodeForEmail(email, orgSlug, sessionId) {
  try {
    const r = await axiosAuth.post(`generate-code`, {
      email: email,
      organizationSlug: orgSlug,
      sessionId
    });
    return r.data;
  } catch (error) {
    throw error;
  }
}